<!--双向控制
-->
<template>
	<div class="flex-data" :style="dataStyle">
		<div class='left-div'>
			<div style="height: 0.18rem;line-height: 0.18rem; font-size: 0.13rem;">选择设备</div>
			<virtualDeviceTree ref="virtualLeftDeviceTree" :styleOptions="styleOptions" :dataList="virtualDeviceList" @checkItem="checkLeftDeviceItem"
			 :autoSelectMethod='autoLeftSelect' :style="getTreeStyle" :groupCheckAble='false' :multiSelect='true' class="tree-body">
				<!-- style="background-color: #5599FF;border-radius: 0.05rem;"  -->
			</virtualDeviceTree>
		</div>
		<div class='button-class'>
			<div :key='i' v-for='(button,i) in  buttonList' @click='checkButton(button)'>{{button.name}}</div>
		</div>
		<div class="right-div">
			<div style="height: 0.18rem;line-height: 0.18rem; font-size: 0.13rem;">选择设备组</div>
			<teamAssessmentTree ref="virtualRightDeviceTree" :styleOptions="styleOptions" :dataList="deviceGroupTree" @checkItem="checkRightDeviceItem"
			 :autoSelectMethod='autoRightSelect' :style="getTreeStyle" :groupCheckAble='true' :isDisAble='isDisAble'
			 :multiSelect='false' class="tree-body">
			</teamAssessmentTree>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import deviceStore from '@/cache/deviceStore.js'
	import teamAssessmentStore from '@/cache/teamAssessmentStore.js'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import teamAssessmentTree from '@/components/module/tree/teamAssessmentTree.vue'
	export default {
		components: {
			virtualDeviceTree,
			teamAssessmentTree
		},
		props: {
			rightDefaultValue: {
				type: Object,
				default: () => {
					return {}
				}
			},
			dataStyle: {
				type: Object,
				default: () => {
					return {
						'width': '100%',
						'heigth': '100%'
					}
				}
			},
			leftDataList: {
				type: Array,
				default: () => {
					return []
				}
			},
			rightDataList: {
				type: Array,
				default: () => {
					return []
				}
			},
			isSame: {
				type: Function,
				default: (a, b) => {
					return a == b
				}
			},
			getItemLabel: {
				type: Function,
				default: (a) => {
					return a
				}
			},
			buttonList: {
				type: Array,
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				leftSelect: [],
				rightData: [],
				groupId: 1,
				rightSelect: undefined,
				show: false,
				styleOptions: {
					stateImage: {
						'width': '.15rem',
						'height': '.15rem',
						'padding-right': '0.1rem'
					},
					typeImage: {
						'width': '.18rem',
						'height': '.18rem',
						'padding-right': '0.1rem'
					}
				}
			}
		},
		created() {},
		mounted() {
			if (!isempty(this.tabList)) {
				this.nowTab = this.tabList[0]
			}
			this.setDefaultList()
		},
		destroyed() {},
		computed: {
			// 			rightData(){
			// 				var data  = teamAssessmentStore.getters.get
			// 			},
			getColorById() {
				return id => {
					return resourcesStore.getters.getColorById(id)
				}
			},
			getTreeStyle() {
				return {
					'color': this.getColorById('fontColor'),
					'background-color': '#b1cdff',
					'border-radius': '0.05rem',
				}
			},
			// 			backGroundStyle() {
			// 				var temp = {
			// 					'border-radius': '0.05rem',
			// 					'overflow': 'hidden',
			// 					'box-shadow': '10px 10px 5px #888888'
			// 				}
			// 				temp = Object.assign(temp, resourcesStore.getters.getBackgroudImageStyle('tree/unitdefect_right.png'))
			// 				return temp
			// 			},
			deviceGroupTree() {
				var data = teamAssessmentStore.getters.getDeviceGroupTree
				return isempty(data) ? [] : [data]
			},
			autoRightSelect() {
				return item => { //this.rightSelect
					return this.isSame(this.rightDefaultValue, item)
				}
			},
			autoLeftSelect() {
				return item => {
					return this.leftSelect.includes(item)
				}
			},
			virtualDeviceList() {
				var data = deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [data]
			},
			closeImg() {
				return resourcesStore.getters.getResourcesByName('wedoButton/close.png')
			},
			// 			getImgIcon() {
			// 				return item => {
			// 					if (this.selectList.includes(item)) {
			// 						return resourcesStore.getters.getResourcesByName('checkBox/checkedold.png')
			// 					} else {
			// 						return resourcesStore.getters.getResourcesByName('checkBox/uncheckedlod.png')
			// 					}
			// 				}
			// 			},
			// 			getItemStyle() {
			// 				return item => {
			// 					if (this.selectList.includes(item)) {
			// 						return {
			// 							'color': '#5599FF !important',
			// 							'border': '1px solid #5599FF !important',
			// 						}
			// 					} else {
			// 						return {}
			// 					}
			// 				}
			// 			}
		},
		watch: {},
		methods: {
			isDisAble(item) {
				return item.deviceNo != undefined // "VirtualDeviceGroup"
			},
			checkRightDeviceItem(list) {
				this.rightSelect = list
				var devicelist = []
				if (!isempty(list.next)) {
					function findsonList(item) {
						var list = []
						var sonList = item.next
						if (!isempty(sonList)) {
							list = list.concat(sonList)
							sonList.forEach(item => {
								var templist = findsonList(item)
								if (!isempty(templist)) {
									list = list.concat(templist)
								}
							})
						}
						return list
					}
					devicelist = findsonList(list)

					devicelist = devicelist.filter(i => {
						return i.deviceNo != undefined
					})
				}
				this.leftSelect = []
				devicelist.forEach(d => {
					var aim = findTreeItem(this.virtualDeviceList, item => {
						return item.type == "virtualDevice" && item.no == d.deviceNo
					})
					if (!isempty(aim)) {
						this.leftSelect.push(aim)
					}
				})
				this.$refs.virtualLeftDeviceTree.$refs.treeBean.nowCheckItem = this.leftSelect
			},
			checkLeftDeviceItem(list) {
				this.leftSelect = list
			},
			checkButton(button) {
				button.buttonFunction(this.leftSelect, 'leftSelect', this.rightSelect, 'rightData')
			},
			setDefaultList() {
				if (!isempty(this.defaultList)) {
					this.selectList.addAll(this.defaultList)
				}
			},
			clickItem(item) {
				var index = -1
				for (var i = 0, len = this.selectList; i < len; i++) {
					var temp = this.selectList[i]
					if (this.isSame(item, temp)) {
						index = i
						break
					}
				}
				if (index > -1) {
					this.selectList.splice(index, 1)
				} else {
					this.selectList.push(item)
				}
				this.$emit('checkItem', this.selectList)
			}
		}
	}
</script>

<style scoped>
	.tree-body {
		height: calc(100% - 0.18rem);
		width: 100%;
		/* overflow-y: scroll; */
		/* overflow-x: scroll; */
	}

	.left-div {
		height: calc(100% - 15px);
		border: 1px solid beige;
		width: 35%;
	}

	.right-div {
		/* height: 100%; */
		height: calc(100% - 15px);
		border: 1px solid beige;
		width: 35%;
	}

	.button-class {
		height: 100%;
		width: 18%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
	}

	.button-class div {
		width: 1rem;
		height: 0.3rem;
		line-height: 0.3rem;
		text-align: center;
		font-size: 0.15rem;
		background-color: #5599FF;
		color: white;
		cursor: pointer;
		border: 1px solid ##5599FF;
		border-radius: 0.05rem;
	}

	.flex-data {
		height: 100%;
		display: flex;
		justify-content: space-around;
		align-items: flex-start;
	}

	.item-class img {
		width: 0.15rem;
		height: 0.15rem;
	}

	.item-class {
		font-size: 0.12rem;
		text-align: center;
		line-height: 0.3rem;
		border-radius: 0.1rem;
		color: #C0C0C0;
		border: 1px solid #C0C0C0;
		background-color: white;
		min-width: 1rem;
		border-radius: 0.1rem;
		height: 0.3rem;
	}

	.select {
		color: #5599FF !important;
		border: 1px solid #5599FF !important;
	}
</style>
